import Box from '@mui/material/Box';
import { memo, type ReactElement } from 'react';
import { Outlet } from 'react-router-dom';

/**
 * タブレットビューコンポーネント - 入力エリアのみのシンプルレイアウト
 * PDFプレビューは全画面ドロワーで表示されます
 */
export const TabletView = memo((): ReactElement => {
  // タブレット時はPDFプレビューエリアを除外し、入力エリアのみ表示
  return (
    <Box
      sx={{
        marginTop: 3,
        padding: 3,
        minHeight: 'calc(100vh - 120px)',
        maxWidth: '900px',
        margin: '0 auto',
        width: '100%',
        // タッチスクロールの最適化
        WebkitOverflowScrolling: 'touch',
        // セーフエリア対応
        paddingBottom: 'env(safe-area-inset-bottom)',
        paddingLeft: 'max(24px, env(safe-area-inset-left))',
        paddingRight: 'max(24px, env(safe-area-inset-right))',
      }}
    >
      <Outlet />
    </Box>
  );
});

TabletView.displayName = 'TabletView';
